<template>
  <Teleport to="body">
    <Transition enter-active-class="ease-out duration-200"
                enter-from-class="opacity-0"
                leave-active-class="ease-in duration-200"
                leave-to-class="opacity-0">
      <div v-show="isOpen" @click="onCancel" class="fixed z-1000 inset-0 overflow-y-auto bg-black bg-opacity-50" :class="`page-color-${color}`">
        <div class="flex items-center justify-center h-screen min-h-500px">
          <Transition
            enter-active-class="ease-out duration-200"
            enter-from-class="opacity-0 scale-95"
            leave-active-class="ease-in duration-200"
            leave-to-class="opacity-0 scale-95">
            <div v-if="isOpen" @click.stop
                 class="overflow-auto max-h-[80vh] lg:max-w-[95vw]">
              <div class="p-6 bg-white rounded-1">
                <slot></slot>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>

  const props = defineProps({
    controller: Object,
    color: String,
    preventClose: Boolean,
  });

  const emit = defineEmits(['cancel']);

  const { controller } = toRefs(props);
  const { isOpen, close } = controller.value;

  const onCancel = (e) => {
    if (props.preventClose === false) {
      close();
      emit('cancel');
    }
  };
</script>

<style lang="scss">
  .page-color {
    &-blue{
      --page-color: var(--color-blue);
      --page-light: var(--light-blue);
    }
    &-indigo{
      --page-color: var(--color-indigo);
      --page-light: var(--light-indigo);
    }
    &-green{
      --page-color: var(--color-success);
      --page-light: var(--light-success);
    }
    &-orange{
      --page-color: var(--color-orange);
      --page-light: var(--light-orange);
    }
    &-red{
      --page-color: var(--color-red);
      --page-light: var(--light-red);
    }
  }
</style>
